module.exports = __webpack_public_path__ + "static/logo-da20f8b7450701237397e07269a4ceeb.png";